"use client";

import { useEffect, useRef, type JSX } from "react";
import { type SearchSortProps } from "./search-sort.props";
import { useSearchEngine } from "src/hooks/useSearchEngine";
import { loadSortCriteriaActions, SortBy, SortOrder } from "@coveo/headless";
import { SortCriterion } from "@coveo/atomic-react";

// SearchSort is an editing-only metadata-hint component — at runtime its
// fields are consumed by the search engine elsewhere; the rendering itself
// just visualises the configured criteria for content authors.
export const Default = (props: SearchSortProps): JSX.Element => {
  console.log("---->[SearchSort:Default] Component", props.fields);

  const { page, fields } = props;
  const isPageEditing = page.mode.isEditing;

  const sortsAppliedRef = useRef<boolean>(false);
  const searchEngine = useSearchEngine(props.params.SearchScope);

  useEffect(() => {
    if (sortsAppliedRef.current) return;
    if (!searchEngine) return;

    const sortActions = loadSortCriteriaActions(searchEngine);
    const fieldEntries = Object.entries(fields ?? {});

    const criteria: SortCriterion[] = fieldEntries.map(
      ([field, direction]) => ({
        by: SortBy.Field,
        field,
        order:
          direction === "Ascending"
            ? SortOrder.Ascending
            : SortOrder.Descending,
      }),
    );

    const sortExpression = sortActions.registerSortCriterion(criteria);
    searchEngine.dispatch(sortExpression);

    sortsAppliedRef.current = true;
  }, [searchEngine, fields]);

  if (!isPageEditing) return <></>;

  return (
    <div
      className={`is-metadata-hint ${props.params?.styles}`}
      data-role="search-sort-dynamic-default-component"
    >
      <strong>Search sort criteria</strong>
      <div>
        {Object.entries(fields ?? {}).map(([field, direction]) => (
          <pre key={field}>
            <strong>{field}: </strong>
            {direction}
          </pre>
        ))}
      </div>
    </div>
  );
};
